/* eslint-disable prefer-rest-params */

function loadZhiChi(w: any, d: any, e: any, x: any) {
  w[e] = function () {
    w.cbk = w.cbk || [];
    w.cbk.push(arguments);
  };
  x = d.createElement('script');
  x.async = true;
  x.id = 'zhichiScript';
  x.className = 'zhichiButtonClass';
  x.src =
    'https://hetaocontest.sobot.com/chat/frame/v2/entrance.js?sysnum=a4b3b00a1e0d46e593523500ffff41e9';
  d.body.appendChild(x);
}

function init(w: any, d: any, e: any, x?: any) {
  loadZhiChi(w, d, e, x);
  window.zc('config', {
    container_style: 'right: 10px',
    color: 'ff6a00',
    custom: true,
    channelid: 5,
    powered: false,
    width: 360,
    height: 550,
    auto_expand: true,
  });
}

export function initZhiChi() {
  init(window, document, 'zc');
}
